// extracted by mini-css-extract-plugin
export default {"configTitle":"EntryFieldGeneric-module-configTitle-qHSr2","fieldRoot":"EntryFieldGeneric-module-fieldRoot-C3GcO","error":"EntryFieldGeneric-module-error-GXf0D"};